import React from 'react'

import type { IconProps } from '@phosphor-icons/react'

import type { PhosphorIconName } from './iconNames'
import { iconRegistry } from './iconRegistry.web'

export interface PhosphorIconProps extends Omit<IconProps, 'ref'> {
  name: PhosphorIconName
}

const PhosphorIcon = ({ name, ...rest }: PhosphorIconProps) => {
  const IconComponent = iconRegistry[name]

  if (!IconComponent) {
    return null
  }

  return <IconComponent {...rest} />
}

export default PhosphorIcon
